import React from "react"

import globalStyles from "../../../../App.module.scss"
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter"
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism"

let example = `#!/usr/bin/env bash

verbose=false
output="out.txt"

while getopts ":vo:h" opt; do
    case "$opt" in
        v) verbose=true ;;
        o) output="$OPTARG" ;;
        h) echo "Usage: $0 [-v] [-o file] [-h]"; exit 0 ;;
        \\?) echo "Unknown option: -$OPTARG" >&2; exit 1 ;;
        :) echo "Option -$OPTARG requires an argument" >&2; exit 1 ;;
    esac
done
shift $(( OPTIND - 1 ))

echo "verbose=$verbose output=$output remaining args: $@"`

export default function Getopts() {
    return (
        <div className={globalStyles.article}>
            <h1>Argument parsing (getopts)</h1>
            <p>The bash builtin for parsing short flags (<code>-v</code>, <code>-o file</code>). It doesn't
                handle GNU-style long options (<code>--verbose</code>) — for those, either parse
                <code> $@</code> by hand in a loop or reach for the external <code>getopt</code> command.</p>

            <SyntaxHighlighter
                children={example}
                style={dracula}
                PreTag="div"
                language={'bash'}
            />

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '500px'}}>
                    <thead>
                    <tr>
                        <th>Symbol</th>
                        <th>Meaning</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><code>:vo:h</code></td>
                        <td>Leading <code>:</code> enables silent error handling; <code>o:</code> means
                            <code> -o</code> takes an argument</td>
                    </tr>
                    <tr>
                        <td><code>$opt</code></td>
                        <td>The current flag letter</td>
                    </tr>
                    <tr>
                        <td><code>$OPTARG</code></td>
                        <td>The value passed to a flag that takes an argument</td>
                    </tr>
                    <tr>
                        <td><code>$OPTIND</code></td>
                        <td>Index of the next argument — use <code>shift $(( OPTIND - 1 ))</code> afterward
                            to drop the parsed flags and leave positional args in <code>$@</code></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}
